import { useAuth0 } from '@auth0/auth0-react';
import UserMenuItem from '../UserMenuItem/UserMenuItem';
import { UserMenuDialogType } from '../UserMenuDialog/UserMenuDialog';

export default function UserAvatar() {
  const { user } = useAuth0();

  return (
    <UserMenuItem
      id="btnUserAvatar"
      ariaLabel={user ? `${user.name}'s Avatar` : 'User Avatar'}
      dialogType={UserMenuDialogType.UserAvatar}
      icon={
        user ? (
          <img
            src={user.picture}
            className="h-full w-full rounded-full"
            alt={user ? `${user.name}'s Avatar` : 'User Avatar'}
            title="Click to logout"
          />
        ) : undefined
      }
    />
  );
}
